import css from './CircleLoader.module.css';

export interface CircleLoaderProps {
    loaderColor?: string;
    loaderSize?: number;
    loaderSpeed?: number;
}

export const CircleLoader: React.FC<CircleLoaderProps> = ({
    loaderColor = 'var(--button-primary-text)',
    loaderSize = 25,
    loaderSpeed = 1.2,
}) => {
    return (
        <div
            className={css.buttonLoader}
            style={
                {
                    '--loader-size': `${loaderSize}px`,
                    '--loader-color': loaderColor,
                    '--loader-speed': `${loaderSpeed}s`,
                } as React.CSSProperties
            }
        >
            <div className={css.customLoader}>
                <div className={css.dot}></div>
                <div className={css.dot}></div>
                <div className={css.dot}></div>
                <div className={css.dot}></div>
                <div className={css.dot}></div>
                <div className={css.dot}></div>
                <div className={css.dot}></div>
                <div className={css.dot}></div>
            </div>
        </div>
    );
};
